module.exports = __webpack_public_path__ + "img/ta.f5b44003.png";